import postRequest from '../../../../../postRequest';

/**
 * Calls attributes endpoint to get products attributes.
 *
 * @param {number} productId - 15974689
 * @param {string} siteCode - JD
 * @returns {Promise} { data: { Data: [{}], Pagination: {} }, status: 200 }
 */
async function postAttributes(productId, siteCode) {
  const endpoint = '/integration-pim/v1/products/drop-shipment/attributes';

  const body = {
    productId,
    siteCode,
  };
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Attributes')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postAttributes;
